export default "/images/bff5fded073d9f57400542de29a16551.avif";